// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-properties-description-renderer__input {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/entity-common/ui/row-renderers/DescriptionRenderer.less"],"names":[],"mappings":"AACE;EACE,OAAA;AAAJ","sourcesContent":[".entity-properties-description-renderer {\n  &__input {\n    flex: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
